/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FaceScanStrictHttpResponse } from '../../face-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanSdkScanConfigRequestModel } from '../../models/scan-sdk-scan-config-request-model';
import { SdkConfigModel } from '../../models/sdk-config-model';

export interface ScanSdkScanConfigPost$Params {
      body?: ScanSdkScanConfigRequestModel
}

export function scanSdkScanConfigPost(http: HttpClient, rootUrl: string, params?: ScanSdkScanConfigPost$Params, context?: HttpContext): Observable<FaceScanStrictHttpResponse<SdkConfigModel>> {
  const rb = new RequestBuilder(rootUrl, scanSdkScanConfigPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as FaceScanStrictHttpResponse<SdkConfigModel>;
    })
  );
}

scanSdkScanConfigPost.PATH = '/Scan/SDKScanConfig';
